import { addWindowResizeEvent } from '@theme/utilities';

const setCalendarItemWidth = (container: HTMLElement) => {
	let maxWidth = 0;
	const items = container.querySelectorAll<HTMLElement>('.calendar__item');

	// Remove the width property from all items
	items.forEach((item) => item.style.removeProperty('--width'));

	// Find the widest item
	items.forEach((item) => {
		maxWidth = Math.max(maxWidth, item.offsetWidth);
	});

	// Set all items to the widest width
	items.forEach((item) => {
		item.style.setProperty('--width', `${maxWidth}px`);
	});

	container.classList.add('calendar--initialized');
};

const init = () => {
	document.querySelectorAll<HTMLElement>('.calendar').forEach(setCalendarItemWidth);
};

init();
addWindowResizeEvent(init);
